import { api } from "./api"

export interface Notification {
  id: string
  title: string
  message: string
  type: number
  isRead: boolean
  readAt?: string
  actionUrl?: string
  createdAt: string
}

export const notificationService = {
  getAll: (unreadOnly = false) =>
    api.get<Notification[]>(`/notifications?unreadOnly=${unreadOnly}`).then(r => r.data),
  markRead: (id: string) =>
    api.put(`/notifications/${id}/read`),
  markAllRead: () =>
    api.put("/notifications/read-all"),

  getVapidPublicKey: () =>
    api.get<{ vapidPublicKey: string }>("/push/vapid-public-key").then(r => r.data.vapidPublicKey),
  subscribe: (subscription: PushSubscriptionJSON) =>
    api.post("/push/subscribe", {
      endpoint: subscription.endpoint,
      p256dh: subscription.keys?.p256dh,
      auth: subscription.keys?.auth,
      userAgent: navigator.userAgent,
    }),
  unsubscribe: (endpoint: string) =>
    api.post("/push/unsubscribe", { endpoint }),
}
